/**
 * Le donateur doit-il voir « 66 % du don est déductible des impôts — votre
 * reçu fiscal sera envoyé par e-mail » ?
 *
 * OUI seulement si l'API le dit EXPLICITEMENT. Elle seule croise l'interrupteur
 * de l'asso, son identité officielle (RNA ou SIRET) et son habilitation réelle
 * (mandat signé, déclaration cultuelle à jour).
 *
 * ⚠️ Fermé par défaut. La page /pay lisait `showFiscalInfo !== false` : une
 * réponse SANS l'info valait « oui ». Or une asso qui n'a jamais ouvert les
 * réglages de sa page de paiement reçoit `paymentPage: null` — le verdict
 * « non » se perdait avec, et la page promettait un reçu fiscal que l'asso
 * n'émettra jamais (DSPGY, 2 dons pour 1 066,46 €, Karim 2026-10-04).
 *
 * Le verdict est lu au premier niveau de la réponse (toujours présent depuis
 * le 2026-10-04), puis dans `paymentPage` pour une API pas encore à jour.
 */
export function recuFiscalAnnonce(
  data:
    | {
        showFiscalInfo?: boolean | null;
        paymentPage?: { showFiscalInfo?: boolean | null } | null;
      }
    | null
    | undefined,
): boolean {
  const verdict = data?.showFiscalInfo ?? data?.paymentPage?.showFiscalInfo;
  return verdict === true;
}
